export default __webpack_public_path__ + "static/media/SP_2.b4785903.PNG";